import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	getInvoices: null,
	getInvoicesDone: ['invoices', 'message'],
	getInvoicesError: ['errorMessage'],
	addInvoice: ['invoice'],
	addInvoiceDone: ['message'],
	addInvoiceError: ['errorMessage'],
});

export const INITIAL_STATE = {
	invoices: [],
	message: '',
	errorMessage: '',
	loading: false,
};

export const InvoicesTypes = Types;
export default Creators;

const fetchRequest = (state) => ({
	...state,
	loading: true,
});

const getInvoicesDone = (state, { invoices, message }) => ({
	...state,
	loading: false,
	message,
	invoices,
})

const showErrorMessage = (state, { errorMessage }) => ({
	...state,
	loading: false,
	errorMessage,
});

const showMessage = (state, { message }) => ({
	...state,
	message,
	loading: false,
})

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_INVOICES]: fetchRequest,
	[Types.GET_INVOICES_DONE]: getInvoicesDone,
	[Types.GET_INVOICES_ERROR]: showErrorMessage,
	[Types.ADD_INVOICE]: fetchRequest,
	[Types.ADD_INVOICE_DONE]: showMessage,
	[Types.ADD_INVOICE_ERROR]: showErrorMessage,
});